import { getHiddenAttribute } from "./hiddenAttributes";

export const fetchInvoiceAttributes = async (data) => {
  let fetchData = [];

  for (const [key, value] of Object.entries(data)) {
    if (value.type === "hidden" && (value.value === null || value.value === undefined)) {
      fetchData.push({ "attribute": value.id, "value": await getHiddenAttribute(value.name) ?? "" });

    } else {
      fetchData.push({ "attribute": value.id, "value": value.value ?? "" });
    }
  }

  return fetchData;
};
